module.exports = __webpack_public_path__ + "img/2.a59beda8.png";